<template>
  <section id="Lookup" class="section-item">
    <h1>{{ $t("title.lookup") }}</h1>

    <section id="api-Lookup-GetLookupNumbersNumber">
      <h2>{{ $t("title.lookup") }} - {{ $t("title.number_lookup") }}</h2>
      <p>{{ $t("lookup.lookup_numbers_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/lookup/numbers/:number</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">CURL</button>
        <pre>
          <code class="language-bash">curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/lookup/numbers/5513951427199' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \</code>
        </pre>

        <h3>{{ $t("general.header") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>String</td>
              <td>
                {{ $t("general.default_value")
                }}<span class="app-json">application/json</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>country_code</td>
              <td>String</td>
              <td>{{ $t("table.country_code") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.cell_number") }}</td>
            </tr>
            <tr>
              <td>national_format</td>
              <td>String</td>
              <td>{{ $t("table.national_format_number") }}</td>
            </tr>
            <tr>
              <td>ported_at</td>
              <td>String</td>
              <td>{{ $t("table.portability_date") }}</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.number_status") }}.</td>
            </tr>
            <tr>
              <td>carrier</td>
              <td>Object</td>
              <td>{{ $t("table.carrier") }}</td>
            </tr>
            <tr>
              <td>network_code</td>
              <td>Number</td>
              <td>{{ $t("table.carrier_code") }}</td>
            </tr>
            <tr>
              <td>name</td>
              <td>Number</td>
              <td>{{ $t("table.carrier_name") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">{{ $t("general.success") }}</button>

        <pre>
      <code class="language-json">HTTP/1.1 200 OK
{
"country_code": "BR",
"phone_number": "+5513951427199",
"national_format": "(13) 95144-7199",
"ported_at": null,
"status": "active",
"carrier": {
  "network_code": "55341",
  "name": "TIM"
}
}</code>
    </pre>

        <button class="btn02">Error-Response</button>
        <pre>
      <code class="language-json">{
"error": "Error message"
}</code>
    </pre>
      </div>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "LookupComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-section {
  margin-top: 30px;
  text-align: start;
}

.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
